module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('t-dropdown', {
    staticClass: "pagination__options-size-changer show",
    attrs: {
      "trigger": "click"
    },
    on: {
      "on-visible-change": _vm.$_onTDropDownVisibleChange
    }
  }, [_c('t-button', {
    staticClass: "pagination__options-size-select"
  }, [_vm._v("\n    " + _vm._s(_vm.current) + _vm._s(_vm.itemPerPage) + "\n    "), _c('t-icon', {
    attrs: {
      "type": _vm.iconType ? 'chevron-up' : 'chevron-down'
    }
  })], 1), _vm._v(" "), _c('t-dropdown-menu', {
    staticClass: "pagination__options-size-list",
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, _vm._l((_vm.range), function(i) {
    return _c('t-dropdown-item', {
      key: i,
      on: {
        "on-click": function($event) {
          return _vm.$_onTDropDownClick(i)
        }
      }
    }, [_vm._v(_vm._s(i))])
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b8b78580"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pager/sizer.vue
// module id = 404
// module chunks = 0